import classNames from 'classnames';
import React, { FC, useEffect, useRef } from 'react';
import styles from "../ContentBlocks.module.css";
import he from "he";
import { ImageGallery } from 'components/molecules/ImageGallery';
import $ from "jquery";
import { useDeviceClassification } from 'utils';
import { TextEditor } from 'components/molecules/TextEditor';

type TSimpleSplitImageTextCarouselBlockProps = {
    BlockContentOrientation: string;
    Images: { Src: string, Alt: string }[];
    HeadingSuperscript: string,
    HeadingLarge: string,
    Description: string,
    bgColor?: string,
    mobile: boolean;
    showCaptions: boolean;
    interval?: number;
    autoPlay: boolean;
    determineSlideType: string;
}

export const SimpleSplitImageTextCarouselBlock: FC<TSimpleSplitImageTextCarouselBlockProps> = ({
    showCaptions,
    BlockContentOrientation,
    Images,
    HeadingSuperscript = "",
    HeadingLarge = "",
    Description,
    bgColor,
    mobile,
    autoPlay,
    interval,
    determineSlideType
}) => {

    // Ref's
    const textRef = useRef(null);
    const headingRef = useRef(null);
    // Device Classification
    const { isDesktop } = useDeviceClassification();

    // After DOM renders, adjust height of DOM nodes.
    useEffect(() => {
        // Node Heights
        const textHeight = textRef?.current?.getBoundingClientRect()?.height;
        const headingHeight = headingRef?.current?.getBoundingClientRect()?.height;
        const imageWrapperHeight = $('.SimpleSplitImageTextCarouselBlockWrapper .imageWrapper').height();

        $('.SimpleSplitImageTextCarouselBlockWrapper').css({ minHeight: `${textHeight}px` });
        $('.SimpleSplitImageTextCarouselBlockWrapper .imageOverlay').css({ minHeight: `${headingHeight + 50}px` });

        // isDesktop && $('.SimpleSplitImageTextCarouselBlockWrapper .imageWrapper').css({ height: `${imageWrapperHeight < headingHeight ? headingHeight : imageWrapperHeight}px` });
        // !isDesktop && $('.SimpleSplitImageTextCarouselBlockWrapper .imageWrapper').css({ height: `${headingHeight > imageWrapperHeight / 3 ? headingHeight * 3 : imageWrapperHeight}px` });

    }, [textRef, headingRef]);

    // Conditionals
    const renderHeading = Boolean(HeadingSuperscript) && Boolean(HeadingLarge);

    // Component
    const Headings: FC<{ right?: boolean }> = ({ right }) => (<div ref={headingRef} className="heading" style={{
        paddingTop: '50px',
        gridColumn: 'span 6',
        paddingLeft: !isDesktop ? '0px' : right ? '50px' : '0px',
        paddingRight: !isDesktop ? '0px' : right ? '0px' : '50px'
    }}>
        <h2 className="super-script">{he.decode(HeadingSuperscript).toUpperCase()}</h2>
        <h2 className="heading-large">{he.decode(HeadingLarge)}</h2>
    </div>)

    return (
        <div
            style={{ minHeight: textRef.current?.getBoundingClientRect()?.height }}
            className={classNames(styles.SimpleSplitImageTextCarouselBlockWrapper, "SimpleSplitImageTextCarouselBlockWrapper")}
        >

            {mobile ?
                <div className="content">
                    <div
                        className={classNames(`slice imageWrapper`, { renderHeading: renderHeading }, { mobile: mobile })}>
                        <ImageGallery
                            legendClassName={'mb-80'}
                            noCaption={!showCaptions}
                            className={"right"}
                            autoPlay={autoPlay}
                            interval={interval}
                            images={Images}
                        />

                        <div className="imageOverlay"></div>
                        {renderHeading && <Headings />}
                        
                    </div>

                    <div style={{ position: 'relative', zIndex: -1, background: bgColor }} className="slice">
                        <div ref={textRef} className="text postcontent c-block">
                            <div className="text-editor-wrapper" style={{ gridColumn: 'span 6' }}>
                                <TextEditor data={Description} />
                            </div>
                        </div>
                    </div>
                </div>
                :
                <>
                    {BlockContentOrientation === "Text Right and Carousel Left" &&
                        <div className="content">

                            <div ref={textRef} className="text postcontent c-block">
                                {renderHeading && <Headings />}
                                <div className="text-editor-wrapper" style={{ gridColumn: 'span 6 / -1'}}>
                                    <TextEditor data={Description} />
                                </div>
                            </div>

                            <div
                                className={classNames("slice slide-in-from-left imageWrapper", { renderHeading: renderHeading }, { mobile: mobile })}>
                                <ImageGallery
                                    noCaption={!showCaptions}
                                    className={"right"}
                                    autoPlay={autoPlay}
                                    interval={interval}
                                    images={Images}
                                />
                                <div className="imageOverlay"></div>
                            </div>

                            <div className="slice" style={{ background: bgColor, zIndex: "-1", height: '70vh' }}></div>
                        </div>

                    }
                    {BlockContentOrientation === "Text Left and Carousel Right" &&
                        <div className="content">

                            <div ref={textRef} className="text postcontent c-block">
                                <div className="text-editor-wrapper" style={{ gridColumn: 'span 6' }}>
                                    <TextEditor data={Description} />
                                </div>
                                {renderHeading && <Headings right />}
                            </div>

                            <div className="slice" style={{ background: bgColor, zIndex: "-1", height: '70vh' }}></div>

                            <div
                                className={classNames("slice imageWrapper", { renderHeading: renderHeading }, { mobile: mobile })}>
                                <ImageGallery
                                    noCaption={!showCaptions}
                                    className={"right"}
                                    autoPlay={autoPlay}
                                    interval={interval}
                                    images={Images}
                                />
                                <div className="imageOverlay"></div>
                            </div>
                        </div>
                    }
                </>
            }

        </div>
    )
};